<template>
  <div
    class="nav-bar-container"
    :style="{ background: variables[`${style}-top-bar-background`] }"
  >
    <div class="left-panel">
      <ht-logo class="logo-padding" />

      <ht-breadcrumb class="hidden-xs-only" />

      <el-input
        ref="searchInput"
        v-model.trim="pattern"
        :placeholder="placeholder"
        clearable
        @clear="handleSearch"
      >
        <template #prepend>
          <el-select
            :key="searchType"
            v-model="searchType"
            popper-class="search-type"
            style="width: 110px"
          >
            <el-option value="user" :label="$t('eip.nav.user')">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M12 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 2a2 2 0 0 0-2 2a2 2 0 0 0 2 2a2 2 0 0 0 2-2a2 2 0 0 0-2-2m0 7c2.67 0 8 1.33 8 4v3H4v-3c0-2.67 5.33-4 8-4m0 1.9c-2.97 0-6.1 1.46-6.1 2.1v1.1h12.2V17c0-.64-3.13-2.1-6.1-2.1"
                ></path>
              </svg>

              <span>{{ $t('eip.nav.user') }}</span>
            </el-option>
            <el-option value="flow" :label="$t('eip.nav.flow')">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M3 18h18v2H3v-2m0-4h18v2H3v-2m0-4h18v2H3V8m0-4h18v2H3V4z"
                ></path>
              </svg>

              <span>{{ $t('eip.nav.flow') }}</span>
            </el-option>
            <el-option value="document" :label="$t('eip.nav.document')">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6m-2 16H8v-2h4v2m0-4H8v-2h4v2m0-4H8V8h4v2m6 8h-4v-2h4v2m0-4h-4v-2h4v2m0-4h-4V8h4v2z"
                ></path>
              </svg>

              <span>{{ $t('eip.nav.document') }}</span>
            </el-option>
          </el-select>
        </template>
        <template #append>
          <el-button icon="el-icon-search" @click="handleSearch" />
        </template>
      </el-input>
    </div>

    <div class="right-panel">
      <ht-translate v-if="$i18n.locale !== ZH_CODE" />
      <ht-handbook />
      <ht-language />
      <ht-theme-bar class="hidden-xs-only" />
      <ht-file-download-notice
        ref="fileDownloadNotice"
        :accept="accept"
        :trigger="'hover'"
      />
      <ht-message :message-count="messageCount" @msg-click="linkToMessage" />
      <el-divider direction="vertical" />
      <ht-avatar />
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import variables from '@/styles/variables.scss'
  import portal from '@/api/portal'
  import { ZH_CODE } from '@transsion/hotent-ui/packages/Language'

  export default {
    name: 'HtNavBar',

    data() {
      return {
        variables,
        searchType: 'user',
        pattern: '',
        exportSuccessHandler: null,
        ZH_CODE,
      }
    },

    computed: {
      ...mapGetters({
        messageCount: 'navHeader/getUnreadMsgCount',
        collapse: 'settings/collapse',
        visitedRoutes: 'tabsBar/visitedRoutes',
        routes: 'routes/routes',
        style: 'settings/style',
        layout: 'settings/layout',
      }),

      accept() {
        return {
          downloadList: portal.sysAsyncEvent,
          downLoad: portal.downloadFileById,
          manualExecute: portal.manualExecuteEvent,
          delete: portal.deleteTaskById,
          deleteAll: portal.deleteTaskAll,
        }
      },

      placeholder() {
        switch (this.searchType) {
          case 'user':
            return this.$t('eip.nav.userPlaceholder')
          case 'flow':
            return this.$t('eip.nav.flowPlaceholder')
          case 'document':
            return this.$t('eip.nav.documentPlaceholder')
        }

        return ''
      },

      navSearchProps() {
        return {
          type: this.searchType,
          pattern: this.pattern,
        }
      },
    },

    watch: {
      $route: {
        immediate: true,
        handler() {
          this.pattern = ''

          this.handleSearch()
        },
      },

      // navSearchProps: {
      //   deep: true,
      //   immediate: true,
      //   handler() {
      //     this.handleSearch()
      //   },
      // },
    },

    created() {
      if (this.$i18n.locale === 'id') {
        this.$i18n.mergeLocaleMessage('id', {
          eip: {
            nav: {
              user: 'pengguna',
            },
          },
        })
      }
    },

    mounted() {
      this.$store.dispatch('navHeader/setUnreadMsgCount')

      this.$refs.searchInput.$el.addEventListener('keydown', this.handleEnter)
      this.exportSuccessHandler = () => {
        this.$refs.fileDownloadNotice &&
          this.$refs.fileDownloadNotice.refresh &&
          this.$refs.fileDownloadNotice.refresh()
      }
      this.$baseEventBus.$on('file-export-success', this.exportSuccessHandler)
    },

    beforeDestroy() {
      this.$refs.searchInput.$el.removeEventListener(
        'keydown',
        this.handleEnter
      )
      this.exportSuccessHandler &&
        this.$baseEventBus.$off(
          'file-export-success',
          this.exportSuccessHandler
        )
    },

    methods: {
      ...mapActions({
        changeCollapse: 'settings/changeCollapse',
      }),
      linkToMessage() {
        this.$router.push('/personal/message')
      },
      handleCollapse() {
        this.changeCollapse()
      },
      handleEnter(e) {
        if (e.code !== 'Enter') return

        this.handleSearch()
      },
      handleSearch() {
        this.$baseEventBus.$emit('nav-search-event', this.navSearchProps)
      },
    },
  }
</script>

<style lang="scss" scoped>
  ::v-deep .iconfont {
    font-size: 26px;
    color: #8f99ac;
  }

  .nav-bar-container {
    position: relative;
    display: flex;
    justify-content: space-between;
    height: $base-nav-bar-height;
    overflow: hidden;
    user-select: none;
    box-shadow: $base-box-shadow;

    .left-panel {
      display: flex;
      flex: 1;
      align-items: center;
      justify-content: flex-start;
      height: $base-nav-bar-height;

      .el-input {
        min-width: 200px;
        max-width: 600px;
        margin-left: 80px;

        ::v-deep {
          .el-input-group__prepend {
            .el-select {
              .el-input {
                .el-input__inner {
                  border-color: transparent !important;
                }
              }
            }
          }
        }

        // ::v-deep {
        //   .el-input-group__prepend {
        //     .el-select {
        //       .el-input--suffix {
        //         color: #fff;
        //         background-color: var(--themeColor);
        //         border-radius: 4px 0 0 4px;

        //         .el-input__inner {
        //           border-color: var(--themeColor);
        //         }

        //         .el-input--suffix {
        //           color: #fff;
        //         }
        //       }
        //     }
        //   }

        //   .el-input__inner {
        //     border-color: var(--themeColor);
        //   }

        //   .el-input-group__append {
        //     border-color: var(--themeColor);
        //     .el-button {
        //       color: #fff;
        //       background-color: var(--themeColor);
        //       border-radius: 0 4px 4px 0;
        //     }
        //   }
        // }
      }
    }

    .right-panel {
      display: flex;
      flex: none;
      align-content: center;
      align-items: center;
      justify-content: flex-end;
      height: $base-nav-bar-height;

      > div,
      span {
        cursor: pointer;

        &:hover {
          opacity: 0.8;
        }
      }

      .handbook {
        margin: 0 10px;
        font-size: 20px;
        i {
          color: #8f99ac;
          &:hover {
            opacity: 0.8;
          }
        }
      }

      div:not(.el-divider--vertical),
      span {
        margin: 0 10px;
      }

      ::v-deep {
        svg {
          width: 26px;
          height: 26px;
          font-size: $base-font-size-small;
          color: $base-color-gray;
          vertical-align: middle;
          cursor: pointer;
          fill: var(--topRightColor);
        }

        button {
          svg {
            margin-right: 0;
            color: $base-color-white;
            cursor: pointer;
            fill: var(--topRightColor);
          }
        }
        .el-divider--vertical {
          height: 20px !important;
          margin: 0 16px;
          background: #f0f0f0 !important;
        }
      }
    }
  }
</style>

<style lang="scss">
  .search-type {
    .el-select-dropdown__item {
      display: flex;
      align-items: center;
      svg {
        margin-right: 10px;
      }
    }
  }
</style>
